export const VIDEO_MODAL_SELECTORS = {
   GALLERY_TAB_PANEL: '#videoGallery',
   GENERAL_TAB_BUTTON: 'button[data-bs-target="#videoGeneral"]',
   VIDEO_URL_INPUT: '#videoUrlInput',
   VIDEO_WIDTH_INPUT: '#videoWidthInput',
   VIDEO_HEIGHT_INPUT: '#videoHeightInput',
   VIDEO_UPLOAD_CONTAINER: '#videoUploadContainer',
} as const;